// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"93dc7c055375a178","3100":"65024aa8596e1244"}[chunkId] + ".css";
};